import type { ErrorLevel } from "./capture-properties";

export interface Breadcrumb {
  category?: string;
  message?: string;
  level?: ErrorLevel;
  data?: Record<string, unknown>;
}

const BREADCRUMB_LIMIT = 30;

const trail: Array<Breadcrumb & { timestamp: string }> = [];

export function addBreadcrumb(breadcrumb: Breadcrumb) {
  trail.push({ ...breadcrumb, timestamp: new Date().toISOString() });
  if (trail.length > BREADCRUMB_LIMIT) {
    trail.splice(0, trail.length - BREADCRUMB_LIMIT);
  }
}

export function readBreadcrumbs(): Array<Breadcrumb & { timestamp: string }> {
  return [...trail];
}
